import Model from './voucher.model'

let storeContent = utils.generateStore({
   Model,
   voucher: null,
   voucher_payment: null,
   check_status_interval: null,
   is_payment_made: false,
   failure_reason: '',
   payment_failed: false,
   current: 1
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async fetchData(ctx) {
         try {
            // await ctx.dispatch('fetchVouchers')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
      async previousPage(ctx) {
         try {
            if(ctx.getters.current > 1 && ctx.getters.current != 3){
               ctx.commit('current',ctx.getters.current - 1)
            }
         } catch (err) {
            throw err
         }
      },
      async saveCard(ctx,payload) {
         try {
            let user = payload.customer_details.form_data_
            let voucher_cards = payload.voucher_cards.form_data_

            if(await payload.customer_details.isValid() && await payload.voucher_cards.isValid()){
               let res = await api.fetchEndpoint({
                  resource: 'coupon',
                  action: 'add:voucher',
                  data: {
                     names: user.names,
                     phone_number: user.phone_number,
                     email: user.email,
                     cards: voucher_cards
                  },
                  meta_data: {}
               })

               ctx.commit('voucher',res.result)
               ctx.commit('current',3)
            }
         } catch (err) {
            throw err
         }
      },
      async payVoucher(ctx,payload) {
         try {
            if(await payload.payment_type.isValid()){
               let res = await api.fetchEndpoint({
                  resource: 'coupon',
                  action: 'pay:voucher',
                  data: {
                     voucher_id: ctx.getters.voucher?.voucher._id,
                     payment_type: payload.payment_type.form_data_.payment_type
                  },
                  meta_data: {}
               })

               // Constantly check if payment is confirmed
               ctx.commit('check_status_interval', setInterval(async () => {
                  await ctx.dispatch('checkPaymentStatus')
               }, (process.env.VUE_APP_PAYMENT_CHECK_INTERVAL_SECONDS || 15) * 1000))
               ctx.commit('current',4)
            }
         } catch (err) {
            throw err
         }
      },
      async checkPaymentStatus(ctx) {
         try {
            // Reset the messages
            if(ctx.getters.payment_failed){
               ctx.commit('is_payment_made',false)
               ctx.commit('payment_failed',false)
               ctx.commit('failure_reason','')
            }

            let res = await api.fetchEndpoint({
               resource: 'coupon',
               action: 'stk_push_status:voucher',
               data: {
                  voucher_id: ctx.getters.voucher?.voucher._id,
               },
               meta_data: {}
            })

            if(res.result?.voucher?.is_paid || (res.result?.data?.mpesa?.status === 'success')){
               ctx.commit('voucher_payment',res.result.voucher)
               ctx.commit('is_payment_made',true)

               if(ctx.getters.check_status_interval){
                  clearInterval(ctx.getters.check_status_interval)
               }
            }else if(res.result.data && res.result.data.reason){
               $notify('error', 'Transaction Failed', res.result.data.reason)
               ctx.commit('payment_failed',true)
               ctx.commit('failure_reason',res.result.data.reason)

               if(ctx.getters.check_status_interval){
                  clearInterval(ctx.getters.check_status_interval)
               }
            }
         } catch (err) {
            throw err
         }
      },
      async nextPage(ctx,payload) {
         try {
            ctx.commit('loading', true)

            if(ctx.getters.current === 1 && await payload.customer_details.isValid()){
               ctx.commit('current',2)
            }else if(ctx.getters.current === 2){
               await ctx.dispatch('saveCard',payload)
            }else if(ctx.getters.current === 3){
               await ctx.dispatch('payVoucher',payload)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
   }
}